module.exports = __webpack_public_path__ + "assets/img/4b8ed84d5179ebe798cff6f21437bbf7.svg";